import  axiosClient  from "./../Network/apiClient"

const PlotService = {

    getPlots: () => {
        return axiosClient.get('/plots');
    },

    getStartFolders: () => {
        return axiosClient.get('/plots/startfolders')
    },

    getRegionFolders: (start, search) => {
        return axiosClient.get(`/plots/regionfolders?start=${start}&search=${search||''}`)
    },

    getLocations: (start, region, search) => {
        return axiosClient.get(`/plots/locations?start=${start}&region=${region||-1}&search=${search||''}`)
    },


}

export default PlotService
